const production = {
  pubnubPublishKey: 'pub-c-fb8ac7e3-75bf-4396-bf14-77215f8b9419',
  pubnubSubscribeKey: 'sub-c-78deef00-680f-11e5-a57f-0619f8945a4f',
  rootUrl: '.getvisitapp.com',
  apiBaseUrl: 'https://api.getvisitapp.com/v4',
  notificationChannel: 'visit-network-requests',
  verificationUrl: 'https://payments.getvisitapp.com',
  googleAuthConfig: {
    clientId:
      '587654000125-b8vv1k8u3u58k7c68bl1cil76gmldrn6.apps.googleusercontent.com',
    scopes: ['email', 'profile', 'openid'],
  },
  networkBaseUrl: 'https://network.getvisitapp.com',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAm9jhep23-QqlHfxbsHiBp8Ux7O5vi_Q8',
  useNativeGoogleAuth: true,
  onDemandOauthBaseUrl: 'https://api.getvisitapp.com/v3',
};

export default production;
